import styled from 'styled-components';

export const Layout = styled.main`
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
`;
